import { c as _c } from "react/compiler-runtime";
import { BoxProps, Button, Circle, Heading, HStack, Icon, Image, SimpleGrid, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';
import { SignupPaymentForm } from '@src/components/sco/Account/SignupPaymentForm';
import { SignupRequestPreviewCard } from '@src/components/sco/Requests/SignupRequestBuilder/PreviewStep';
import { generateSignupRequestPreviewTitle } from '@src/components/sco/Requests/SignupRequestBuilder/helpers';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ScoSignupRequest } from '@src/graphql-types';
import React from 'react';
import { LuCheck } from 'react-icons/lu';
export const SignupRequestPaymentStep = props => {
  const $ = _c(45);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t0 = props.borderRadius;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [1, 1, 2];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== getBreakpointValue) {
    t2 = getBreakpointValue([2, 4, 6]);
    $[1] = getBreakpointValue;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== getBreakpointValue) {
    t3 = getBreakpointValue([2, 4, 6]);
    $[3] = getBreakpointValue;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.signupRequest) {
    t4 = generateSignupRequestPreviewTitle(props.signupRequest);
    $[5] = props.signupRequest;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = props.groupRequestType?.title;
  let t6;
  if ($[7] !== props.signupRequest.investorIndustryTagTitles) {
    t6 = props.signupRequest?.investorIndustryTagTitles || [];
    $[7] = props.signupRequest.investorIndustryTagTitles;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== props.signupRequest.skillTagTitles) {
    t7 = props.signupRequest?.skillTagTitles || [];
    $[9] = props.signupRequest.skillTagTitles;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== props.signupRequest.createdByIpLocation || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = [t5, ...t6, ...t7, props.signupRequest.createdByIpLocation].filter(Boolean);
    $[11] = props.signupRequest.createdByIpLocation;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== props) {
    t9 = () => props.setShowStep("edit");
    $[16] = props;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t8 || $[20] !== t9) {
    t10 = <SignupRequestPreviewCard title={t4} tags={t8} onEditClick={t9} />;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SignupRequestPaymentContentContent />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t2 || $[25] !== t3) {
    t12 = <VStack alignSelf="stretch" background="colorPalette.panel" gap={t2} justify="center" padding={t3} width="full">{t10}{t11}</VStack>;
    $[23] = t10;
    $[24] = t2;
    $[25] = t3;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== getBreakpointValue) {
    t13 = getBreakpointValue([2, 4, 6]);
    $[27] = getBreakpointValue;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== props) {
    t14 = () => props.setShowStep("commit");
    $[29] = props;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      margin: 0
    };
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14) {
    t16 = <SignupPaymentForm afterSuccess={t14} containerProps={t15} productId="scom-accelerator-tools" />;
    $[32] = t14;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Text>Not ready yet?</Text>;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== props) {
    t18 = <HStack bgColor="blackAlpha.400" borderRadius="md" justify="space-between" padding={2}>{t17}<Button size="xs" variant="outline" onClick={() => props.setShowStep("commit")}>Continue Exploring</Button></HStack>;
    $[35] = props;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t13 || $[38] !== t16 || $[39] !== t18) {
    t19 = <VStack align="stretch" background="LightBlue50" gap={2} justify="start" padding={t13} width="full">{t16}{t18}</VStack>;
    $[37] = t13;
    $[38] = t16;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== props.borderRadius || $[42] !== t12 || $[43] !== t19) {
    t20 = <SimpleGrid borderRadius={t0} columns={t1} gap={0} overflow="hidden">{t12}{t19}</SimpleGrid>;
    $[41] = props.borderRadius;
    $[42] = t12;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  return t20;
};
export const SignupRequestPaymentContentContent = props => {
  const $ = _c(21);
  const {
    getBreakpointValue,
    isMobile
  } = useBreakpointContext();
  const t0 = isMobile ? "lg" : "xl";
  let t1;
  if ($[0] !== t0) {
    t1 = <Heading size={t0}>Join to Unlock Your Matches</Heading>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text fontSize="lg">You'll be able to modify your goal before it goes live.</Text>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <VStack align="center" direction="column" gap={2} justify="center" textAlign="center" width="full">{t1}{t2}</VStack>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== getBreakpointValue) {
    t4 = getBreakpointValue([1, 1, 3]);
    $[5] = getBreakpointValue;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = FeatureGridItemArray.map(_temp);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <SimpleGrid columns={t4} gap={4} width="full">{t5}</SimpleGrid>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== getBreakpointValue) {
    t7 = getBreakpointValue([1, 1, 2, 2, 2]);
    $[10] = getBreakpointValue;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatureGridItemMedium heading="Best Investment Ever" text="Startups Pro includes curated investor matches." />;
    t9 = <FeatureGridItemMedium heading="Does it Work?" text="Over $1.2B in capital commitments on our platforms." />;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7) {
    t10 = <SimpleGrid columns={t7} gap={4} width="full">{t8}{t9}</SimpleGrid>;
    $[14] = t7;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FeatureGridItemLarge heading="Over 1.3 million startups like you started here" logos={ClientLogoArray} />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t3 || $[19] !== t6) {
    t12 = <VStack alignSelf="stretch" flex={2} gap={5} justify="center" width="full">{t3}{t6}{t10}{t11}</VStack>;
    $[17] = t10;
    $[18] = t3;
    $[19] = t6;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
};
const CircleIcon = props => {
  const $ = _c(9);
  let t0;
  if ($[0] !== props.as) {
    t0 = <props.as />;
    $[0] = props.as;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.boxSize || $[3] !== props.color || $[4] !== t0) {
    t1 = <Icon asChild={true} boxSize={props.boxSize} color={props.color}>{t0}</Icon>;
    $[2] = props.boxSize;
    $[3] = props.color;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== t1) {
    t2 = <Circle bgColor={props.fill} boxShadow="md" padding={1} {...props}>{t1}</Circle>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
const FeatureGridItemSmall = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CircleIcon as={LuCheck} boxShadow="xs" boxSize={6} color="white" fill="green.600" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.text) {
    t1 = <VStack align="center" bgColor="colorPalette.container" borderRadius="xl" boxShadow="sm" direction="column" gap={2} justify="start" padding={4} textAlign="center">{t0}<Text fontSize="xs">{props.text}</Text></VStack>;
    $[1] = props.text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const FeatureGridItemMedium = props => {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.heading) {
    t0 = <Heading size="md">{props.heading}</Heading>;
    $[0] = props.heading;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.text) {
    t1 = <Text fontSize="sm">{props.text}</Text>;
    $[2] = props.text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <VStack align="center" bgColor="colorPalette.container" borderRadius="xl" boxShadow="sm" direction="column" gap={0} justify="center" padding={4} textAlign="center">{t0}{t1}</VStack>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const FeatureGridItemLarge = props => {
  const $ = _c(9);
  let t0;
  if ($[0] !== props.heading) {
    t0 = <Heading size="xl">{props.heading}</Heading>;
    $[0] = props.heading;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.logos) {
    t1 = props.logos.map(_temp2);
    $[2] = props.logos;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <Wrap gap={10} justify="center" opacity={0.5} width="full">{t1}</Wrap>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <VStack align="center" bg="linear-gradient(to bottom, BurntOrange50, black)" borderRadius="xl" direction="column" gap={8} justify="start" padding={10} textAlign="center" width="full">{t0}{t2}</VStack>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const ClientLogo = props => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props.alt || $[1] !== props.src) {
    t0 = <WrapItem><Image alt={props.alt} maxHeight="20px" objectFit="contain" src={props.src} width="full" /></WrapItem>;
    $[0] = props.alt;
    $[1] = props.src;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
const ClientLogoArray = [{
  src: require('@public/assets/graphics/client-logos/bumble-logo.svg').default.src,
  alt: 'Bumble Logo'
}, {
  src: require('@public/assets/graphics/client-logos/instacart-logo.svg').default.src,
  alt: 'Instacart Logo'
}, {
  src: require('@public/assets/graphics/client-logos/vevo-logo.svg').default.src,
  alt: 'Vevo Logo'
}, {
  src: require('@public/assets/graphics/client-logos/arcimoto-logo.png').default.src,
  alt: 'Arcimoto Logo'
}, {
  src: require('@public/assets/graphics/client-logos/ag1-logo.svg').default.src,
  alt: 'AG1 Logo'
}];
const FeatureGridItemArray = [
// { text: (text: string) => `Unlock ${text} matches for your Request` },
{
  text: 'Directly contact exactly who you want'
}, {
  text: 'Make your goal visible to 250,000+ professionals'
}, {
  text: 'Access to Live Expert Workshops, Courses'
}];
function _temp(item, index) {
  return <FeatureGridItemSmall key={index} text={item.text as string} />;
}
function _temp2(logo, index) {
  return <ClientLogo key={index} alt={logo.alt} src={logo.src} />;
}